import React, { useState, useEffect } from 'react';
import './BrochurePopup.css';
import { toSentenceCase } from '../utils/textUtils';

function BrochurePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    // Vérifier si le popup a déjà été montré dans cette session
    const hasSeenPopup = sessionStorage.getItem('brochurePopupSeen');
    
    if (!hasSeenPopup) {
      // Afficher le popup après 30 secondes
      const timer = setTimeout(() => {
        setIsVisible(true);
        sessionStorage.setItem('brochurePopupSeen', 'true');
      }, 30000); // 30 secondes

      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsVisible(false);
    }, 300);
  };

  const handleDownload = () => {
    // Créer un lien de téléchargement
    const link = document.createElement('a');
    link.href = '/documents/brochure-gsu-palmiers.pdf';
    link.download = 'Brochure-GSU-Les-Palmiers.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    // Fermer le popup après téléchargement
    handleClose();
  };

  if (!isVisible) return null;

  return (
    <>
      <div className={`popup-overlay ${isClosing ? 'closing' : ''}`} onClick={handleClose}></div>
      <div className={`brochure-popup ${isClosing ? 'closing' : ''}`}>
        <button className="popup-close" onClick={handleClose}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

        <div className="popup-content">
          <div className="popup-icon">
            <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <line x1="12" y1="18" x2="12" y2="12"></line>
              <line x1="9" y1="15" x2="15" y2="15"></line>
            </svg>
          </div>

          <h3>{toSentenceCase("Découvrez notre brochure")}</h3>
          <p>
            {toSentenceCase("Téléchargez gratuitement la brochure complète du GSU Les Palmiers et découvrez toutes nos filières, nos programmes et nos opportunités.")}
          </p>

          <div className="popup-features">
            <div className="feature-item">
              <span className="feature-icon">📚</span>
              <span>{toSentenceCase("Toutes les filières")}</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🎓</span>
              <span>{toSentenceCase("Programmes détaillés")}</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">💼</span>
              <span>{toSentenceCase("Débouchés professionnels")}</span>
            </div>
          </div>

          <div className="popup-buttons">
            <button className="btn-download" onClick={handleDownload}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
              {toSentenceCase("Télécharger la brochure")}
            </button>
            <button className="btn-later" onClick={handleClose}>
              {toSentenceCase("Plus tard")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default BrochurePopup;
